import { Version } from '@fuse/version/version';

export const FUSE_VERSION = new Version('21.0.0').full;
